import BedsApi from "./BedsApi";
import Imroom from "./Imroom";

class PropertyService {

    static MULTIPLICATEUR = 1.03
    static NAS_URL_IMG = "http://imroom.fr/ahc/"
    static properties = {
        // propId
        // 124572: {
        //     // Cathédrale
        //     propKey: '2dde010d6f00e45b420573776457080c',
        //     apiKey: process.env.REACT_APP_BEDS_API_TOKEN_NAT,
        //     roomId: '279537',
        //     minPrice: 75
        // },
        110237: {
            // Grand Prieuré
            propKey: 'c6d15ac5-7392-4e96-82de-ed576f710ea7',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_ARNAUD,
            roomId: '250038',
            minPrice: 88
        },
        110241: {
            // Grand Voile
            propKey: '28117c92-f160-4f32-9dd3-2bb6e33cd3b0',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_ARNAUD,
            roomId: '250042',
            minPrice: 44
        },
        110239: {
            // Lessard
            propKey: '39ee6212-2ed5-4e4a-80ca-a45f8c8c1a64',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_ARNAUD,
            roomId: '250040',
            minPrice: 44
        },
        110238: {
            // Vauban
            propKey: 'f6c12e54-5a22-4517-bb54-1077a4e72250',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_ARNAUD,
            roomId: '250039',
            minPrice: 44
        },
        110240: {
            // Lacroix
            propKey: '49c26ec1-801e-47ff-96c6-6bc13d9d81ea',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_ARNAUD,
            roomId: '250041',
            minPrice: 44
        },
        110516: {
            propKey: 'c8f8f674-a242-4380-ac00-2936e5be5622',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_DIDIER
        },
        110469: {
            propKey: 'de411c10-cc69-4488-82ac-bd04f5cbb4cf',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_DIDIER
        },
        138626: {
            // Lafayette 39
            propKey: '0648b92e-0568-4353-83df-36a27a941f97',
            apiKey: process.env.REACT_APP_BEDS_API_TOKEN_ARNAUD,
            roomId: '309321',
            minPrice: 33
        },
        161831: {
            // Lafayette 41
            propKey: 'pD7g445qYVdY5iF2',
            apiKey:  process.env.REACT_APP_BEDS_API_TOKEN_DIDIER,
            roomId: '356354',
            minPrice: 33
        },
        191016: {
            // Marne 1850
            propKey: '22ff8c48-c224-4c26-b4c6-4e92211c7624',
            apiKey:  process.env.REACT_APP_BEDS_API_TOKEN_LHB_SAS,
            roomId: '411835',
            minPrice: 50
        },
        217051: {
            // Marne 1850
            propKey: 'z9UaX36sM4Dsx68z6BzR',
            apiKey:  process.env.REACT_APP_BEDS_API_TOKEN_LHB_SAS,
            roomId: '461555',
            minPrice: 50
        }
    }

    static fillArray = (properties, newData) => {
        newData.getProperties.forEach((property, index) => {
            let propId = newData.getProperties[index].propId;
            if (typeof PropertyService.properties[propId] !== "undefined") {
                newData.getProperties[index].image = PropertyService.NAS_URL_IMG + property.propId + ".png";
                newData.getProperties[index].roomTypes[0].minPrice = PropertyService.properties[propId].minPrice;
                properties.push(newData.getProperties[index]);
            }
        })
        return properties;
    }

    static getProperties = () => {
        return new Promise(resolve => {
            let properties = [];
            //resolve(JSON.parse('[{"name":"★ Appart\'HomeCity | Rouen Vue Cathédrale ★","propId":"124572","propTypeId":"1","ownerId":"69399","currency":"EUR","address":"17c avenue jacques chastellain","city":"ROUEN","state":"NORMANDIE","country":"FR","postcode":"76100","latitude":"49.4337476","longitude":"1.0986466","roomTypes":[{"name":"★ Appart\'HomeCity | Rouen Vue Cathédrale ★","qty":"1","roomId":"279537","minPrice":46,"maxPeople":"6","maxAdult":"6","maxChildren":"3","unitAllocationPerGuest":"0","unitNames":""}],"image":"http://imroom.fr/ahc/124572.png"},{"name":"★ Appart\'HomeCity | Rouen Grand Prieuré ★","propId":"110237","propTypeId":"1","ownerId":"61875","currency":"EUR","address":"43 rue pierre renaudel","city":"Rouen","state":"Normandie","country":"FR","postcode":"76100","latitude":"49.4271090","longitude":"1.0901000","roomTypes":[{"name":"★ Appart\'HomeCity | Rouen Grand Prieuré ★","qty":"1","roomId":"250038","minPrice":52,"maxPeople":"6","maxAdult":"6","maxChildren":"4","unitAllocationPerGuest":"0","unitNames":""}],"image":"http://imroom.fr/ahc/110237.png"},{"name":"★ Appart\'HomeCity | Rouen Vauban ★","propId":"110238","propTypeId":"1","ownerId":"61875","currency":"EUR","address":"1 rue du Grand Feu","city":"Rouen","state":"Normandie","country":"FR","postcode":"76100","latitude":"49.4330030","longitude":"1.0815281","roomTypes":[{"name":"★ Appart\'HomeCity | Rouen Vauban ★","qty":"1","roomId":"250039","minPrice":41,"maxPeople":"4","maxAdult":"4","maxChildren":"2","unitAllocationPerGuest":"0","unitNames":""}],"image":"http://imroom.fr/ahc/110238.png"},{"name":"★ Appart\'HomeCity | Rouen Lessard ★","propId":"110239","propTypeId":"1","ownerId":"61875","currency":"EUR","address":"111 rue de lessard","city":"Rouen","state":"Normandie","country":"FR","postcode":"76100","latitude":"49.4324310","longitude":"1.0911630","roomTypes":[{"name":"★ Appart\'HomeCity | Rouen Lessard ★","qty":"1","roomId":"250040","minPrice":41,"maxPeople":"2","maxAdult":"2","maxChildren":"1","unitAllocationPerGuest":"0","unitNames":""}],"image":"http://imroom.fr/ahc/110239.png"},{"name":"★ Appart\'HomeCity | Rouen Ile Lacroix Seine ★","propId":"110240","propTypeId":"1","ownerId":"61875","currency":"EUR","address":"17b avenue Jacques Chastellain","city":"Rouen","state":"Normandie","country":"FR","postcode":"76100","latitude":"49.4332401","longitude":"1.0994254","roomTypes":[{"name":"★ Appart\'HomeCity | Rouen Ile Lacroix Seine ★","qty":"1","roomId":"250041","minPrice":41,"maxPeople":"4","maxAdult":"4","maxChildren":"2","unitAllocationPerGuest":"0","unitNames":""}],"image":"http://imroom.fr/ahc/110240.png"},{"name":"★ Appart\'HomeCity | Rouen Grand Voile ★","propId":"110241","propTypeId":"1","ownerId":"61875","currency":"EUR","address":"29 Rue Parmentier","city":"Rouen","state":"Normandie","country":"FR","postcode":"76100","latitude":"49.4253450","longitude":"1.0697590","roomTypes":[{"name":"★ Appart\'HomeCity| Rouen Grand Voile ★","qty":"1","roomId":"250042","minPrice":41,"maxPeople":"4","maxAdult":"4","maxChildren":"2","unitAllocationPerGuest":"0","unitNames":""}],"image":"http://imroom.fr/ahc/110241.png"},{"name":"★ Appart\'HomeCity | Rouen Lafayette 39 ★","propId":"138626","propTypeId":"1","ownerId":"61875","currency":"EUR","address":"2 allée marcel dupré","city":"Rouen","state":"Normandie","country":"FR","postcode":"76100","latitude":"49.4321392","longitude":"1.0881481","roomTypes":[{"name":"★ Appart\'HomeCity | Rouen Lafayette 39 ★","qty":"1","roomId":"309321","minPrice":31,"maxPeople":"2","maxAdult":"2","maxChildren":"1","unitAllocationPerGuest":"0","unitNames":""}],"image":"http://imroom.fr/ahc/138626.png"}]'))

            //BedsApi.call('post', '/getProperties', {}, {apiKey: process.env.REACT_APP_BEDS_API_TOKEN_NAT}).then(res => {
                //properties = PropertyService.fillArray(properties, res.data)

                BedsApi.call('post', '/getProperties', {}, {apiKey: process.env.REACT_APP_BEDS_API_TOKEN_LHB_SAS}).then(res => {
                    properties = PropertyService.fillArray(properties, res.data)

                    BedsApi.call('post', '/getProperties').then(res => {
                        properties = PropertyService.fillArray(properties, res.data)
                        resolve(properties);
                        /*BedsApi.call('post', '/getProperties', {}, {apiKey: process.env.REACT_APP_BEDS_API_TOKEN_DIDIER}).then(res => {
                            properties = PropertyService.fillArray(properties, res.data)
                            resolve(properties);
                        })*/
                    })
                })
            //})
        })
    }

    static getProperty = (propKey) => {
        return new Promise(resolve => {
            BedsApi.call('post', '/getProperty', {}, { propKey: PropertyService.properties[propKey].propKey, apiKey: PropertyService.properties[propKey].apiKey }).then(res => {
                resolve(res.data.getProperty[0])
            })
        })
    }

    static getPropertiesWithDates = (properties, from, to) => {
        return new Promise(resolve => {
            let newProperties = []
            let url = "/tools/ahc"

            let data = {
                'ownerid': 61875,
                'checkin': from,
                'checkout': to
            }

            Imroom.call(url, data).then(propertiesId => {
                Object.keys(properties).map(key => {
                    let property = properties[key]
                    if (propertiesId.data.includes(property.propId)) {
                        newProperties.push(property)
                    }
                })
                resolve(newProperties)
            })
        })
    }
}
export default PropertyService;
